import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import $ from 'jquery';

Component('tr-prototype-project-clone-card', {
  mixins: [eventListenerMixin],

  connected() {
    const curUserId = $('input#user-id[type="hidden"]').val();
    this.channel = window.tower.tempPusher(
      `${process.env.PUSHER_CHANNEL_PREFIX}user-${curUserId}`,
    );

    // 从样板间模板复制项目，完成后通知客户端
    this.channel.bind('project_clone', (data) => {
      window.simple.loading.destroy();
      window.location.href = data.project_url;
    });
  },

  disconnected() {
    this.channel.unbind('project_clone');
  },
});
